import { Props } from "react-select";
import { CreatableProps } from "react-select/creatable";
import { MutableRefObject } from "react";

export type DefaultOption = {
  label: string | null;
  value: string;
};

export const AsyncLoadOptionTypeEnum = {
  VEHICLE: "vehicle",
  VEHICLES: "vehicles",
  VENDOR: "vendor",
  ASSIGNED_TO: "assigned_to",
  VEHICLE_VENDOR: "vehicle_vendor",
  LABELS: "labels",
  DRIVER: "driver",
  USER: "user",
  EXPENSE_TYPE: "expense_type",
  LABEL: "label",
  TELEMATIC_DEVICE: "telematic_device",
  ROLE: "role",
  GROUP: "group",
  SERVICE_TASK: "service_task",
  EQUIPMENT_TYPE: "equipment_type",
  PART_CATEGORY: "category",
  PART_MANUFACTURER: "part_manufacturer",
  VEHICLE_TYPE: "vehicle_type",
  VEHICLE_MODEL: "vehicle_model",
  VEHICLE_MAKE: "vehicle_make",
  FUEL_TYPE: "fuel_type",
  MAINTENANCE_CATEGORY: "maintenance_category",
  SYSTEM_CODE: "system_code",
  ASSEMBLY_CODE: "assembly_code",
  REASON_FOR_REPAIR_CODE: "reason_for_repair_code",
  PAYMENT_TYPE: "payment_type",
  RENEWAL_TYPE: "renewal_type",
  CONTACT: "contact",
  CODE: "code",
  LINKED_VEHICLE: "linked_vehicle",
  ASSIGNED_USER: "assigned_user",
  MEASUREMENT_UTNIT: "measurement_unit",
  MANUFACTURER: "manufacturer",
  LOCATION: "location",
  OWNERSHIP_GROUP: "ownerShipGroup",
  // LOCATION: "adress",
} as const;

export type AsyncLoadOptionType =
  (typeof AsyncLoadOptionTypeEnum)[keyof typeof AsyncLoadOptionTypeEnum];

export type SelectProps<T> = {
  name?: string;
  loading?: boolean;
  isCreatable?: boolean;
  asyncLoadOptionType?: AsyncLoadOptionType;
  defaultOptions?: T[] | boolean;
  optionValue?: string;
  optionLabel?: keyof T | string | ((item: T) => string);
  selectRef?: MutableRefObject<null>;
  editOptionValue?: string;
  editOptionLabel?: string;
  onChange?: (newValue: any, actionMeta: any) => void;
} & Omit<CreatableProps<T, boolean, any>, "theme"> &
  Omit<Props<T>, "theme" | "name">;
